// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"23":"d8ea78a0","40":"29e53f57","61":"2df3ae26","142":"7e050f19","387":"55f51e3a","518":"3f0e58aa","520":"f664da3c","621":"228e6eb8","656":"86d40228","952":"77431ed0"}[chunkId] + ".chunk.css";
};